export const UPLOAD_DOCUMENT = "UPLOAD_DOCUMENT";
export const UPLOAD_DOCUMENT_START = "UPLOAD_DOCUMENT_START";
export const UPLOAD_DOCUMENT_SUCCESS = "UPLOAD_DOCUMENT_SUCCESS";
export const UPLOAD_DOCUMENT_ERROR = "UPLOAD_DOCUMENT_ERROR";

export const uploadDocument =
  (userId, file, category, listId) => async (dispatch) => {
    dispatch({ type: UPLOAD_DOCUMENT_START });

    try {
      const response = await fetch("/graphql", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          query: `
          mutation UploadCarDocument($input: CarDocumentInput!) {
            uploadCarDocument(input: $input) {
              id
              userId
              listId
              uploadFile
              category
              uploadedAt
              status
              message
            }
          }
        `,
          variables: {
            input: {
              userId,
              uploadFile: file,
              category: (function(cat) {
                switch (cat) {
                  case 'proof_of_ownership': return 'PROOF_OF_OWNERSHIP';
                  case 'proof_of_insurance': return 'PROOF_OF_INSURANCE';
                  case 'proof_of_maintenance_record': return 'PROOF_OF_MAINTENANCE';
                  default: return cat;
                }
              })(category),
              ...(listId ? { listId } : {}),
            },
          },
        }),
      });

      const result = await response.json();

      if (result.data?.uploadCarDocument) {
        const { uploadCarDocument } = result.data;

        if (uploadCarDocument.status === "success") {
          dispatch({
            type: UPLOAD_DOCUMENT_SUCCESS,
            payload: {
              document: uploadCarDocument,
              message: uploadCarDocument.message,
            },
          });
          return uploadCarDocument;
        } else {
          throw new Error(uploadCarDocument.message);
        }
      } else {
        throw new Error("Failed to upload document");
      }
    } catch (error) {
      dispatch({
        type: UPLOAD_DOCUMENT_ERROR,
        payload: {
          error: error.message || "Failed to upload document",
        },
      });
      throw error;
    }
  };
